// extracted by mini-css-extract-plugin
export default {"error":"ErrorLabel_error__8zdMI"};